import { ColorTokens, BorderRadiusTokens, FontFamilyTokens, IconAlignmentTokens, IconSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, TextAlignTokens, ButtonWidthTypeToken, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import React, { memo } from 'react';
import { ActivityIndicator, Pressable, Platform, View, } from 'react-native';
import Icon from '../icon/Icon';
import Space from '../space/Space';
import Typography from '../typography/Typography';
import { Component as Stack } from '../stack';
import { isFromTDLPlatform } from '../pages/utils';
/**
 * Raw Component with Derived props + Theme
 */
const ButtonBase = ({ id, onPress, label, loading = false, bgColor = ColorTokens.Primary_100, labelColor = ColorTokens.Grey_Night, borderRadius = BorderRadiusTokens.BR5, paddingVertical = SizeTypeTokens.LG, shadow, borderColor, fontSize, lineHeight, fontFamily, iconAlignment, iconName, width = ButtonWidthTypeToken.CONTENT, icon, paddingHorizontal = SizeTypeTokens.XXXXL, triggerAction, action, stack = {
    type: StackType.row,
    justifyContent: StackJustifyContent.center,
    alignItems: StackAlignItems.center,
}, isDisabled = false, height, customWidth }) => {
    /**
     * use type, size, buttonThemePros, colorMapping to full customise base component
     * */
    const theme = ThemeProvider.getTheme();
    const isFromTDL = isFromTDLPlatform();
    const borderRadiusValue = theme.borderRadius[borderRadius];
    const borderColorValue = theme.colors[borderColor];
    const backgroundColorValue = theme.colors[bgColor];
    const labelColorValue = theme.colors[labelColor];
    const paddingValue = theme.space[paddingVertical];
    const shadowValue = theme.shadow[shadow];
    const paddingHorizontalValue = theme.space[paddingHorizontal];
    const iconDetails = {
        align: icon?.name || iconName
            ? IconAlignmentTokens.left
            : null,
        ...icon,
    };
    const styleProps = React.useMemo(() => ({
        backgroundColor: backgroundColorValue,
        borderRadius: isFromTDL ? 8 : borderRadiusValue,
        paddingVertical: borderColor
            ? paddingValue
            : paddingValue + 1,
        borderColor: borderColorValue,
        borderWidth: borderColor ? 1 : 0,
        shadowOffset: shadowValue?.shadowOffset || {
            height: 0,
            width: 0,
        },
        shadowOpacity: shadowValue?.shadowOpacity || 0,
        shadowRadius: shadowValue?.shadowRadius || 0,
        paddingHorizontal: paddingHorizontalValue,
        //	height: 48,
    }), [
        borderRadiusValue,
        borderColorValue,
        backgroundColorValue,
        labelColorValue,
        paddingValue,
        shadowValue,
        paddingHorizontalValue,
    ]);
    const widthStyleProps = React.useMemo(() => Platform.OS === 'web'
        ? {
            width: width === ButtonWidthTypeToken.CONTENT
                ? 'fit-content'
                : customWidth ? customWidth : '100%',
            height: height && height,
        }
        : {
            alignSelf: width === ButtonWidthTypeToken.CONTENT
                ? 'flex-start'
                : 'stretch',
        }, [width]);
    const handleAction = () => {
        if (loading)
            return;
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    const _renderIcon = React.useMemo(() => !loading &&
        (iconName || icon) && (React.createElement(View, { style: {
            width: theme.iconSize[icon?.size] ||
                theme.iconSize[IconSizeTokens[fontSize]],
            alignContent: 'center', alignItems: 'center',
            justifyContent: 'center',
            marginTop: 1
        } },
        React.createElement(Icon, { ...icon, name: iconName || icon.name, size: icon?.size || IconSizeTokens[fontSize], color: labelColor || icon.color }))), [icon, fontSize, iconName]);
    return (React.createElement(Pressable, { disabled: isDisabled, onPress: handleAction, nativeID: id, style: [
            styleProps,
            widthStyleProps,
            { alignItems: 'center', alignContent: 'center', justifyContent: 'center' },
        ] },
        React.createElement(Stack, { ...stack },
            React.createElement(View, { style: { alignContent: 'center', justifyContent: 'center' } }, (iconAlignment === 'left' ||
                iconDetails?.align ===
                    IconAlignmentTokens.left) &&
                _renderIcon),
            (iconAlignment === 'left' ||
                iconDetails?.align ===
                    IconAlignmentTokens.left) &&
                label && React.createElement(Space, { size: SizeTypeTokens.MD }),
            React.createElement(View, { style: { alignContent: 'center', justifyContent: 'center' } },
                React.createElement(Typography, { label: label ? label : '', color: labelColor, fontSize: fontSize, lineHeight: lineHeight, textAlign: TextAlignTokens.center, fontFamily: fontFamily || FontFamilyTokens.Inter, fontWeight: '700' })),
            loading && (React.createElement(ActivityIndicator, { style: { marginLeft: label ? 8 : 0 }, animating: true, color: labelColorValue })),
            (iconAlignment === 'right' ||
                iconDetails?.align ===
                    IconAlignmentTokens.right) &&
                label && React.createElement(Space, { size: SizeTypeTokens.MD }),
            (iconAlignment === 'right' ||
                iconDetails?.align ===
                    IconAlignmentTokens.right) &&
                (iconName || icon) &&
                !loading &&
                _renderIcon)));
};
export default memo(ButtonBase);
export { ButtonBase };
